<template>
<div>


{{ name }}
</div>
</template>


<script>
export default {
  name: "name",
  props: ["id"],

  data() {
    return {
      name:null,
  request: null
    };
  },
  mounted() {
        axios
      .get('admin/Services/Actions/all')
          .then(response => {           this.$root.kick(response.data.message);
        if(response.data.status == "success"){
        this.request = response.data.results.ServiceActions;
        }else{
          this.name = "couldn't fetch service action name"
        }
        this.loading = false;
        console.log(response);

      })
      .catch(error => {
          this.name = "couldn't fetch service action name"

        console.log(error);

      });
//   }
  },
};
</script>
